<template>
  <div>
    <div class="bg" :style="{ background: dynamicColor.rgb }">
      <img class="bacColor" src="../../../static/images/logbg1.png" alt="" />
      <div class="bg_con" v-if="Introduction">
        <div style="width: 33%">
          <p>可用{{ bonusRealName }}</p>
          <!--          <p>{{ Intercept(dividendInformation.bonus) }}</p>-->
          <p>{{ Number(dividendInformation.bonus).toFixed(1) }}</p>
        </div>
        <div style="width: 33%">
          <p>累计发放{{ bonusRealName }}</p>
          <!--          <p>{{ Intercept(dividendInformation.totalBonus) }}</p>-->
          <p>{{ Number(dividendInformation.totalBonus).toFixed(1) }}</p>
        </div>
        <div style="width: 33%">
          <p>过期{{ bonusRealName }}</p>
          <!--          <p>{{ Intercept(dividendInformation.overdueBonus) }}</p>-->
          <p>{{ Number(dividendInformation.overdueBonus).toFixed(1) }}</p>
        </div>
      </div>
      <div class="raiders">
        <span>{{ Introduction.bonusIntroduce }}</span>
        <span @click="raidersCli" style="color: #ffffff">查看详细攻略></span>
      </div>
      <button
        v-if="reduceSwitch != 'false'"
        class="withdraw"
        @click="withdraw"
        :style="{ color: dynamicColor.rgb }"
      >
        权益中心
      </button>

      <div class="returnBut" @click="returnBut">
        <img src="../../../static/images/return_b.png" alt="" />
        <p>返回</p>
      </div>
    </div>
    <div class="listWrap">
      <div class="list" v-for="(item, index) in list" v-if="list.length != 0">
        <h3>{{ item.date }}</h3>
        <ul class="uls">
          <li v-for="(e, x) in item.value">
            <div class="ulsLiLeft">
              <p>{{ e.name }}</p>
              <p>{{ e.time }}</p>
            </div>
            <div class="ulsRight">
              <p
                :style="{
                  color: e.name.endsWith('未领') ? '#878787' : ''
                }"
              >
                {{ e.value }}
              </p>
              <p
                :style="{ color: dynamicColor.rgb }"
                v-if="e.name.endsWith('未领')"
              >
                {{ e.status }}
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div class="load" v-if="pageStat" @click="pagesClick">加载更多</div>

      <div class="noData" v-if="list.length == 0">
        <img src="../../../static/images/empty.png" alt="" />
        <p>暂无记录</p>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { Loading } from "element-ui";
import cookie from "js-cookie";
// var appid = localStorage.getItem("xq-appid");
// var mobile = localStorage.getItem("xq-mobile");
var mobile = cookie.get("xq-mobile");
var appid = cookie.get("xq-appid");
export default {
  name: "index",
  data() {
    return {
      dividendInformation: {}, //分红信息
      apiName: "",
      list: [],
      dynamicColor: {},
      Introduction: {},

      pageStat: true,
      pagesNum: 1,
      loadingInstance: null,
      bonusRealName: "分红",
      contributionRealName: "贡献",
      reduceSwitch: false
    };
  },
  created() {
    this.dynamicColor = JSON.parse(localStorage.getItem("bakColor"));
    this.apiName = this.API1url.API;

    this.$get(this.apiName.realNameData, {
      // 获取分红、贡献真名
        appid: appid,
        mobile: mobile,
    }).then(res => {
      if (res.code == "0000") {
        // this.platformContribution = res.data;
        this.bonusRealName =
          res.data.bonusRealName != null ? res.data.bonusRealName : "分红";
        this.contributionRealName =
          res.data.contributionRealName != null
            ? res.data.contributionRealName
            : "贡献";
      } else {
        Toast.fail("加载失败");
      }
    });
    // this.dividendInformation = this.$store.state.userData == '{}' ? this.$store.state.userData : JSON.parse(localStorage.getItem('userData'));

    this.$get(this.apiName.textDescription, {
        appid: appid,
        mobile: mobile,
    }).then(res => {
      if (res.code == "0000") {
        this.Introduction = res.data;
      }
    });

    this.$get(this.apiName.bonusInfo, {
        appid: appid,
        mobile: mobile,
    }).then(res => {
      if (res.code == "0000") {
        this.$set(this.dividendInformation, "bonus", res.data.bonus);
        this.$set(this.dividendInformation, "totalBonus", res.data.totalBonus);
        this.$set(
          this.dividendInformation,
          "overdueBonus",
          res.data.overdueBonus
        );
      }
    });

    this.$get(this.apiName.Color, {
      token: localStorage.getItem("token"),
    })
      .then(async(res) => {
        if (res.code == "0000") {
          this.reduceSwitch = str.reduceSwitch;
        }
      })

    this.loadingInstance = Loading.service();
    this.listData(this.pagesNum, "");
  },
  methods: {
    pagesClick() {
      var len = this.list[this.list.length - 1];
      this.pagesNum = this.pagesNum + 1;
      this.listData(this.pagesNum, len.key);
    },
    listData(num, name) {
      this.$get(this.apiName.withdrawalsRecord, {
        appid: appid,
        mobile: mobile,
        page: num,
        date: name,
      }).then((res) => {
        if (res.code == "0000") {
          if (res.data.length == 0) {
            this.pageStat = false;
            this.loadingInstance.close();
            Toast.fail("到底了...");
            return false;
          }
          this.loadingInstance.close();
          res.data.forEach((item, index) => {
            // item.value.reverse();
            item.date = item.key.substring(5);
            // item.date =
            this.list.push(item);
          });
        } else {
          Toast.fail("加载失败");
        }
      });
    },
    Intercept(e) {
      var num = e.toString().match(/^\d+(?:\.\d{0,2})?/);
      return num[0];
    },
    withdraw() {
      //this.$router.replace('/Withdraw');
      //更改为跳转第三方提现链接
      // 查询该商户对应的提现地址
      this.$get(this.apiName.withdrawUrl, {
        appid: appid,
        mobile: mobile,
      }).then(res => {
        if (res.code == "0000") {
          if (res.data != null) {
            wx.miniProgram.getEnv((e) => {
              // alert(e.miniprogram)
              if (e.miniprogram) {
                wx.miniProgram.navigateTo({ url: res.data })
              } else {
                window.location = res.data
              }
            })
          }
        }
      });
    },
    returnBut() {
      this.$router.replace("/?token=" + localStorage.getItem("token"));
    },
    raidersCli() {
      this.$router.replace("/Raiders?id=2");
    }
  }
};
</script>

<style scoped>
.bg {
  width: 95%;
  margin: 0 auto;
  height: 220px;
  /*background: url("/static/images/bg.png") center no-repeat;*/
  /*background-size: 100% 100%;*/
  overflow: hidden;
  position: relative;
}

.returnBut {
  position: absolute;
  left: 10px;
  top: 16px;
  z-index: 99;
  display: flex;
  align-items: center;
}

.returnBut > img {
  width: 20px;
  height: 18px;
}

.returnBut > p {
  color: #ffffff;
  font-size: 16px;
}

.bacColor {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
}

.bg_con {
  width: 80%;
  display: flex;
  margin: 50px auto 10px;
  justify-content: space-between;
}

.bg_con > div > p:nth-child(1) {
  color: #ffffff;
  font-size: 14px;
  margin-bottom: 10px;
  text-align: center;
}

.bg_con > div > p:nth-child(2) {
  color: #ffffff;
  font-size: 24px;
  font-family: FZCYJ;
  text-align: center;
}

.withdraw {
  width: 72px;
  height: 32px;
  /*color: #2f80ed;*/
  background: #ecf4ff;
  border: none;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 600;
  margin-left: 24px;
  position: relative;
  z-index: 2;
}

.raiders {
  /*display: flex;*/
  width: 296px;
  font-size: 10px;
  text-align: left;
  margin: 0 auto 16px;
  color: rgba(255, 255, 255, 0.6);
  position: relative;
  z-index: 2;
}

.raiders > span:nth-child(2) {
  font-weight: bold;
}

.listWrap {
  width: 100%;
}

.list {
  margin-top: 24px;
}

.list > h3 {
  font-size: 20px;
  font-family: FZCYJ;
  font-weight: bold;
  margin-left: 16px;
}

.uls > li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 15px 15px 15px;
  border-bottom: 1px solid #ebebeb;
}

.uls > li:last-child {
  border: none;
}

.ulsLiLeft > p:nth-child(1) {
  font-size: 16px;
  margin-bottom: 5px;
}

.ulsLiLeft > p:nth-child(2) {
  font-size: 14px;
  color: #878787;
}

.ulsRight > p:nth-child(1) {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}

.ulsRight > p:nth-child(2) {
  /*color: #2f80ed;*/
  font-size: 14px;
  text-align: center;
}

.noData {
  width: 80px;
  color: #878787;
  font-size: 16px;
  margin: 30px auto 50px;
  text-align: center;
}

.noData > img {
  width: 59px;
  height: 59px;
  display: block;
  margin: 0 auto;
  margin-bottom: 5px;
}
.load {
  width: 100%;
  height: 60px;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #ebebeb;
}
</style>



// WEBPACK FOOTER //
// src/components/dividends/index.vue